class YoutubeMusic {
  constructor (data) {
    this.id = data ? data.id : ''
    this.title = data ? data.title : ''
    this.artist = data ? data.artist : ''
    this.duration = data ? data.duration : ''
    this.link = data ? data.link : ''
    this.audio = data ? data.audio : ''
    this.image = data ? data.image : ''
    this.imageUrl = data ? data.imageUrl : ''
    this.audioUrl = data ? data.audioUrl : ''
    this.created_at = data ? data.created_at : ''
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('title', this.title)
    formData.append('artist', this.artist)
    formData.append('duration', this.duration)
    formData.append('link', this.link)
    formData.append('audio', this.audio)
    formData.append('image', this.image)
    return formData
  }
}

export default YoutubeMusic



// WEBPACK FOOTER //
// ./src/models/YoutubeMusic.js